import { getAssetByCode } from '../services/QuotationsService';
import { hasUsdQuotationConfigured } from './usdQuotationMessages';

export {
  MISSING_USD_QUOTATION_MODAL_BODY,
  MISSING_USD_QUOTATION_MODAL_TITLE,
  hasUsdQuotationConfigured,
} from './usdQuotationMessages';

export async function isUsdQuotationAvailable(): Promise<boolean> {
  try {
    const usdAsset = await getAssetByCode('USD');
    return !!usdAsset && hasUsdQuotationConfigured(usdAsset.saleValue);
  } catch (error) {
    console.error('Error checking USD quotation availability:', error);
    return false;
  }
}
